








import { Vue, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import CounterModule from '@/store/modules/Counter';
import Counter from '@/components/Counter.vue';

@Component({
  components: {
    Counter,
  },
})
export default class CounterView extends Vue {
  CounterInstance = getModule(CounterModule, this.$store);

  incr(delta: number) {
    this.CounterInstance.incr(delta);
  }

  decr(delta: number) {
    this.CounterInstance.decr(delta);
  }
}
